import { createVNode, render } from "vue";
import { useGlobalStore } from "@/store/global";
import router from "@/router";
import PowerInsufficientDialog from "./PowerInsufficientDialog.vue";

export { default as PowerInsufficientDialog } from "./PowerInsufficientDialog.vue";

let dialogPending: Promise<boolean> | null = null;

/**
 * 当前账户影豆是否足够支付本次扣除。
 * 应扣 ≤0 或余额未知时视为通过，交由后端兜底。
 *
 * @param requiredCost 本次需要扣除的影豆
 */
export const isPowerBalanceEnough = (requiredCost: number): boolean => {
  const cost = Math.max(0, Number(requiredCost) || 0);
  if (cost <= 0) {
    return true;
  }
  const balance = useGlobalStore().userInfo?.powerBalance;
  if (typeof balance !== "number" || !Number.isFinite(balance)) {
    return true;
  }
  return balance >= cost;
};

/**
 * 挂载影豆不足弹窗；充值跳转定价页，暂不处理仅关闭。
 * 无论点哪个按钮都返回 false，表示本次业务不要继续。
 * 与 {@link ensurePowerCost} 共用 dialogPending，避免重复弹窗。
 */
export const openPowerInsufficientDialog = (): Promise<boolean> => {
  if (dialogPending) {
    return dialogPending;
  }
  dialogPending = mountPowerInsufficientDialog().finally(() => {
    dialogPending = null;
  });
  return dialogPending;
};

/** 挂载弹窗 DOM（内部实现） */
const mountPowerInsufficientDialog = (): Promise<boolean> => {
  return new Promise((resolve) => {
    const container = document.createElement("div");
    document.body.appendChild(container);
    let settled = false;

    const finish = (goRecharge: boolean) => {
      if (settled) {
        return;
      }
      settled = true;
      render(null, container);
      container.remove();
      if (goRecharge) {
        void router.push("/pricing");
      }
      resolve(false);
    };

    const vnode = createVNode(PowerInsufficientDialog, {
      modelValue: true,
      onRecharge: () => finish(true),
      onDismiss: () => finish(false),
    });
    render(vnode, container);
  });
};

/**
 * 操作前预检影豆：够则返回 true 继续后续流程；不够弹窗并返回 false。
 *
 * @param requiredCost 本次需要扣除的影豆
 */
export const ensurePowerCost = async (requiredCost: number): Promise<boolean> => {
  if (isPowerBalanceEnough(requiredCost)) {
    return true;
  }
  return openPowerInsufficientDialog();
};
